import { UsersAdminForm } from "./users-admin-form";
import { UsersAdminHandler } from "./users-admin-handler";
import { UsersAdminListener } from "./users-admin-listener";
import { UsersAdminRender } from "./users-admin-render";
import { UsersAdminUtils } from "./users-admin-utils";

export class UsersAdminSetup {
    public form: UsersAdminForm;

    public render: UsersAdminRender;

    public handler: UsersAdminHandler;

    public listener: UsersAdminListener;

    public constructor(root: HTMLElement) {
        this.form = new UsersAdminForm(root);
        this.render = new UsersAdminRender(this.form);
        this.handler = new UsersAdminHandler(this.form, this.render);
        this.listener = new UsersAdminListener(this.form, this.handler);
    }

    public async init(): Promise<void> {
        if (this.form.isInitialized()) {
            return;
        }

        this.listener.register();
        this.handler.bootstrap();
        this.form.markInitialized();
    }

    public static async init(scope: Document | HTMLElement | ParentNode = document): Promise<void> {
        const root = scope instanceof HTMLElement || scope instanceof Document ? scope : document;
        const selector = `[data-role="${UsersAdminUtils.ROLES.ROOT}"]`;
        const targets: HTMLElement[] = [];

        if (root instanceof HTMLElement && root.matches(selector)) {
            targets.push(root);
        }

        UsersAdminForm.getRoots(root).forEach((node) => {
            if (node instanceof HTMLElement) {
                targets.push(node);
            }
        });

        for (const target of targets) {
            const setup = new UsersAdminSetup(target);
            await setup.init();
        }
    }
}
